<template>
  <div class="inputSearchComp">
    <input
      id="input_search"
      type="text"
      :placeholder="placeholder"
      v-on:input="$emit('input', $event.target.value)"
      @keyup.enter="searching"
      v-bind:value="value"

      v-mask="mask"
    >
    <input
      id="btn_search"
      type="button"
      @click="searching"
    >
    <input
      id="btn_clear"
      type="button"
      @click="clear"
      value="X"
      v-if="value"
    >
  </div>
</template>

<script>
export default {
  name: 'inputSearchComp',
  props: {
    searching: { type: Function, required: true },
    clear: { type: Function, equired: true },
    value: { type: String, required: false },
    placeholder: { type: String, default: () => 'Поиск...' },
    mask: { type: String, default: () => null }
  },
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.inputSearchComp {
  // width: 252px;
  width: 100%;
  height: 32px;
  position: relative;
}
#btn_search {
  position: absolute;
  padding: 0;
  margin: 0;
  top: calc(50% - 8px);
  right: 10px;
  border: none;
  background-color: transparent;
  background: url('../assets/magnifier.png') no-repeat;
  width: 20px;
  height: 20px;
}
#btn_search:active, #btn_clear:active{
  opacity: 0.5;
}
#btn_clear {
  position: absolute;
  padding: 0;
  margin: 0;
  top: calc(50% - 8px);
  right: 35px;
  border: none;
  background-color: transparent;
  background-color: #ff8200;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #ffffff;
}
#input_search {
  top: 0;
  left: 0;
  position: absolute;
  margin: 0;
  width: calc(100% - 70px);
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 60px;
  color: #202020;
}
#input_search::placeholder {
  color: #bababa;
  font-size: 14px;
}
#btn_clear:hover, #btn_search:hover {
  opacity: 0.5;
  cursor: pointer;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}

</style>
